import { getInitialConfigModel } from '../../../redux/reducers/config';
import { ConfigModel } from '../../../models/ConfigModel';

export const BEXITY = 'BEXITY';
export const MMT = 'MMT';
export const PHL = 'PHL';
export const SIEVERS = 'SIEVERS';
export const GERSTLAUER = 'GERSTLAUER';
export const WDS = 'WDS';
export const HAALBOOM = 'HAALBOOM';

export const CLIENT_KUNDEN = [
  { id: 0, name: BEXITY },
  { id: 1, name: MMT },
  { id: 2, name: PHL },
  { id: 3, name: SIEVERS },
  { id: 4, name: GERSTLAUER },
  { id: 5, name: WDS },
  { id: 6, name: HAALBOOM },
];

export const SERVICES = [
  { id: 0, name: BEXITY },
  { id: 1, name: MMT },
  { id: 2, name: HAALBOOM },
  { id: 3, name: WDS },
];
export const TABLE_CONFIGS = [
  { id: 0, name: BEXITY },
  { id: 1, name: MMT },
  { id: 2, name: WDS },
  { id: 2, name: GERSTLAUER },
];

const assembleBexityConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.auftragsresearchtableconfig = BEXITY;
  configModel.clientKunde = BEXITY;
  configModel.customServices = BEXITY;
  configModel.isBeladedatumVorbelegen = true;
  configModel.isBexPremium = true;
  configModel.isBreitePflichtfeld = true;
  configModel.isDisableUhrzeitfelder = true;
  configModel.isEntladedatumVorbelegen = true;
  configModel.isHoehePflichtfeld = true;
  configModel.isLademeterBerechnen = true;
  configModel.isLaengePflichtfeld = true;
  configModel.isMautrechner = true;
  configModel.isRegistrierung = true;
  configModel.isServicesInternSendungen = true;
  configModel.isTauschgeraete = true;
  configModel.isUserCanEditImmediately = true;
  configModel.isVerkehrsartPflichtfeld = true;
  configModel.isVerkehrsartPflichtfeld = true;
  configModel.isZusaetzlicheLademittel = false;
  configModel.isAdresseEinmaladresseEdit = true;
  configModel.isAdresseKontaktEdit = true;
  configModel.isAdresseTelefonEdit = true;
  configModel.clientMinLengthPw = undefined;
  configModel.isShowEmpfRechnung = true;
  configModel.isShowKlassifizierung = true;
  // track and trace
  configModel.ttEmpfaengerFremdnummer = false;
  configModel.ttEmpfaengerMatchcode = false;
  configModel.ttEmpfaengerStrasse = false;
  configModel.ttInhalt = false;
  configModel.ttVersenderFremdnummer = false;
  configModel.ttVersenderMatchcode = false;
  configModel.ttVersenderStrasse = false;
  configModel.isShowTTMailAdress = false;
  configModel.denyOrderEdit = false;
  configModel.clientInfobox = 'Test-Info BEXity';
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = true;
  configModel.terminArtFixTermin = '4';
  configModel.saveKontaktdaten = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = true;
  configModel.isZustellDatumPflicht = true;
  configModel.isTTSwitchAbsenderToNeutral = false;

  return configModel;
};

const assembleWDSConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.clientKunde = WDS;
  configModel.customServices = BEXITY;
  configModel.dokumentenverweise = true;
  configModel.isBeladedatumVorbelegen = true;
  configModel.isBreitePflichtfeld = true;
  configModel.isCustomstylebuttons = true;
  configModel.isEntladedatumVorbelegen = true;
  configModel.isHoehePflichtfeld = true;
  configModel.isLademeterBerechnen = true;
  configModel.isLaengePflichtfeld = true;
  configModel.isMautrechner = true;
  configModel.isPreisermittlung = true;
  configModel.isUserCanEditImmediately = true;
  configModel.isZusaetzlicheLademittel = true;
  configModel.isShowTTMailAdress = true;
  configModel.isShowEmpfRechnung = false;
  configModel.denyOrderEdit = false;
  configModel.isShowKlassifizierung = false; //neuer config_param
  configModel.clientInfobox = 'Test-Info WDS';
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;

  return configModel;
};

const assembleHaalboomConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.clientKunde = HAALBOOM;
  configModel.dokumentenverweise = true;
  configModel.isBeladedatumVorbelegen = false;
  configModel.isEntladedatumVorbelegen = false;
  configModel.isLademeterBerechnen = true;
  configModel.isUserCanEditImmediately = true;
  configModel.isShowTTMailAdress = true;
  configModel.isShowEmpfRechnung = false;
  configModel.isShowKlassifizierung = false;
  configModel.denyOrderEdit = false;
  configModel.clientInfobox = 'Test-Info Haalboom';
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;

  return configModel;
};

const assemblePHLConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.clientKunde = PHL;
  configModel.isBeladedatumVorbelegen = false;
  configModel.isEntladedatumVorbelegen = false;
  configModel.isLademeterBerechnen = false;
  configModel.isPreisermittlung = true;
  configModel.isStellplaetzeBerechnen = false;
  configModel.isUserCanEditImmediately = true;
  configModel.isZusaetzlicheLademittel = true;
  configModel.isShowTTMailAdress = true;
  configModel.isShowEmpfRechnung = false;
  configModel.isShowKlassifizierung = false;
  configModel.denyOrderEdit = false;
  configModel.clientInfobox = 'Test-Info PHL';
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;

  return configModel;
};

const assembleMMTConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.auftragsresearchtableconfig = MMT;
  configModel.clientKunde = MMT;
  configModel.customServices = MMT;
  configModel.isBeladedatumVorbelegen = true;
  configModel.isDisableUhrzeitfelder = false;
  configModel.isEntladedatumVorbelegen = true;
  configModel.isZusaetzlicheLademittel = true;
  // track and trace
  configModel.ttVersenderMatchcode = false;
  configModel.ttVersenderName = false;
  configModel.ttVersenderStrasse = false;
  configModel.ttVersenderOrt = false;
  configModel.ttVersenderBlockLabel = 'Fremdnummer';
  configModel.ttVersenderFremdnummerLabel = undefined;
  configModel.isShowTTMailAdress = true;
  configModel.isShowEmpfRechnung = false;
  configModel.isShowKlassifizierung = false;
  configModel.denyOrderEdit = true;
  configModel.clientInfobox = 'Test-Info MMT';
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;

  return configModel;
};

const assembleGerstlauerConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.clientKunde = GERSTLAUER;
  configModel.auftragsresearchtableconfig = GERSTLAUER;
  configModel.isBeladedatumVorbelegen = true;
  configModel.isLademeterBerechnen = false;
  configModel.isPreisermittlung = false;
  configModel.isUserCanEditImmediately = true;
  configModel.isZusaetzlicheLademittel = true;
  configModel.isEntladedatumVorbelegen = true;
  configModel.isShowEmpfRechnung = false;
  configModel.isAdresseEinmaladresseEdit = false;
  configModel.isAdresseKontaktEdit = true;
  configModel.isAdresseTelefonEdit = true;
  configModel.isShowTTMailAdress = true;
  configModel.denyOrderEdit = false;
  configModel.isShowKlassifizierung = false; //neuer config_param
  configModel.clientInfobox = 'Test-Info Gerstlauer';
  configModel.isNoADRVerpackungen = true;
  configModel.isNoADRLademittel = true;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = true;
  configModel.isShowAbsenderNeutral = true;
  configModel.isStellplaetzeBerechnen = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;

  return configModel;
};

const assembleSieversConfigModel = (): ConfigModel => {
  const configModel = getInitialConfigModel();
  configModel.clientKunde = SIEVERS;
  configModel.isZusaetzlicheLademittel = true;
  configModel.isEntladedatumVorbelegen = true;
  configModel.isBeladedatumVorbelegen = true;
  configModel.isShowTTMailAdress = true;
  configModel.isShowEmpfRechnung = false;
  configModel.denyOrderEdit = false;
  configModel.isShowKlassifizierung = false; //neuer config_param
  configModel.isNoADRVerpackungen = false;
  configModel.isNoADRLademittel = false;
  configModel.isDenyZustelldatum = false;
  configModel.saveKontaktdaten = true;
  configModel.terminArtFixTermin = '4';
  configModel.isAbsenderEditDeny = false;
  configModel.isShowAbsenderNeutral = false;
  configModel.isAbholDatumPflicht = false;
  configModel.isZustellDatumPflicht = false;
  return configModel;
};

export const changeConfig = (
  kunde: string,
  setConfigModel: (model: ConfigModel) => void
): void => {
  switch (kunde) {
    case BEXITY: {
      const model = assembleBexityConfigModel();
      setConfigModel(model);
      break;
    }
    case WDS: {
      const model = assembleWDSConfigModel();
      setConfigModel(model);
      break;
    }
    case HAALBOOM: {
      const model = assembleHaalboomConfigModel();
      setConfigModel(model);
      break;
    }
    case PHL: {
      const model = assemblePHLConfigModel();
      setConfigModel(model);
      break;
    }
    case MMT: {
      const model = assembleMMTConfigModel();
      setConfigModel(model);
      break;
    }
    case GERSTLAUER: {
      const model = assembleGerstlauerConfigModel();
      setConfigModel(model);
      break;
    }
    case SIEVERS: {
      const model = assembleSieversConfigModel();
      setConfigModel(model);
      break;
    }
  }
};
